import { ChangeEvent, ChangeEventHandler, DOMAttributes, forwardRef, useRef, useState } from "react";
import DatePicker from "react-datepicker";

interface Props {
	// 変更時のイベント
	onChange: (value?: string) => void,
};

/**
 * 日付入力用コンポーネント
 * 
 * @returns 
 */
export default function DateControl(props: Props): JSX.Element {

	/** 強制再描画用 */
	const [, setRefresh] = useState<number | undefined>(undefined);

	/** 年 */
	const [year, setYear] = useState<number | undefined>(undefined);

	/** 月 */
	const [month, setMonth] = useState<number | undefined>(undefined);

	/** 日 */
	const [day, setDay] = useState<number | undefined>(undefined);

	/**
	 * 変更時用イベント
	 */
	const handleChange = (tmpYear: number | undefined, tmpMonth?: number, tmpDay?: number) => {
		props.onChange(getValue(tmpYear, tmpMonth, tmpDay));
		// 表示を更新する。
		setRefresh(Date.now());
	};

	/**
	 * 年変更時イベント
	 * 
	 * @param event 
	 */
	const handleYearChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const tmpYear = event.target.value == '' ? undefined : Number(event.target.value);
		setYear(tmpYear);
		const tmpDay = checkDay(tmpYear, month);
		setDay(tmpDay);
		handleChange(tmpYear, month, tmpDay);
	};

	/**
	 * 月変更時イベント
	 * 
	 * @param event 
	 */
	const handleMonthChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const tmpMonth = event.target.value == '' ? undefined : Number(event.target.value);
		setMonth(tmpMonth);
		const tmpDay = checkDay(year, tmpMonth);
		setDay(tmpDay);
		handleChange(year, tmpMonth, tmpDay);
	};

	/**
	 * 日変更時イベント
	 * 
	 * @param event 
	 */
	const handleDayChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const tmpDay = event.target.value == '' ? undefined : Number(event.target.value);
		setDay(tmpDay);
		handleChange(year, month, tmpDay);
	};

	/**
	 * DatePickerでの変更時イベント
	 * 
	 * @param date 
	 */
	const handlePickerChange = (date: Date | null) => {
		const tmpYear = (date != null ? date.getFullYear() : undefined);
		const tmpMonth = (date != null ? date.getMonth() + 1 : undefined);
		const tmpDay = (date != null ? date.getDate() : undefined);
		setYear(tmpYear);
		setMonth(tmpMonth);
		setDay(tmpDay);
		handleChange(tmpYear, tmpMonth, tmpDay);
	};

	/**
	 * 年と月の変更で日が選択できない値になっている場合に調整する。
	 * 
	 * @param year 
	 * @param month 
	 * @returns 
	 */
	const checkDay = (tmpYear?: number, tmpMonth?: number) => {
		if (day == undefined) {
			return day;
		}

		if (tmpYear == undefined || tmpMonth == undefined) {
			return day;
		}

		const lastDay = new Date(tmpYear, tmpMonth, 0).getDate();
		if (day > lastDay) {
			return lastDay;
		}

		return day;
	};

	/**
	 * 選択している日付を返す。
	 * 
	 * @returns 
	 */
	const getValue = (tmpYear?: number, tmpMonth?: number, tmpDay?: number) => {
		if (tmpYear != undefined && tmpMonth != undefined && tmpDay != undefined) {
			return String(tmpYear) + String(('00' + String(tmpMonth)).slice(-2)) + String(('00' + String(tmpDay)).slice(-2));
		} else if (tmpYear == undefined && tmpMonth == undefined && tmpDay == undefined) {
			return undefined;
		} else {
			return '--------';
		}
	};

	/**
	 * 選択している日付けをDateオブジェクトで返す。
	 * 
	 * @returns 
	 */
	const getDate = () => {
		if (year != undefined && month != undefined && day != undefined) {
			return new Date(year, month - 1, day);
		} else {
			return undefined;
		}
	};

	/**
	 * 年の選択肢を描画する。
	 * 
	 * @returns 
	 */
	const renderYear = () => {

		const thisYear = new Date().getFullYear();
		const list: number[] = [];
		for (let i = 0; i < 11; i++) {
			list.push(thisYear - i);
		}

		return (
			<>
				<option value="">---</option>
				{list.map((year) => (
					<option value={year}>{year}</option>
				))}
			</>
		);
	};

	/**
	 * 月の選択肢を描画する。
	 * 
	 * @returns 
	 */
	const renderMonth = () => {

		const list: number[] = [];
		for (let i = 1; i <= 12; i++) {
			list.push(i);
		}

		return (
			<>
				<option value="">---</option>
				{list.map((month) => (
					<option value={month}>{month}</option>
				))}
			</>
		);
	};

	/**
	 * 日の選択肢を描画する。
	 * 
	 * @returns 
	 */
	const renderDay = () => {

		let lastDay = 31;
		if (year != undefined && month != undefined) {
			lastDay = new Date(year, month, 0).getDate();
		}

		const list: number[] = [];
		for (let i = 1; i <= lastDay; i++) {
			list.push(i);
		}

		return (
			<>
				<option value="">---</option>
				{list.map((day) => (
					<option value={day}>{day}</option>
				))}
			</>
		);
	};

	// 描画する
	return (
		<>
			<select name="year" onChange={handleYearChange} value={String(year)}>
				{renderYear()}
			</select>&nbsp;年&nbsp;
			<select name="month" onChange={handleMonthChange} value={String(month)}>
				{renderMonth()}
			</select>&nbsp;月&nbsp;
			<select name="day" onChange={handleDayChange} value={String(day)}>
				{renderDay()}
			</select >&nbsp;日&nbsp;
			<div style={{ display: 'inline-block' }}>
				<DatePicker selected={getDate()} onChange={handlePickerChange} customInput={
					<img className="ui-datepicker-trigger" src="images/calender.png" alt="From" title="From" />
				} />
			</div>
		</>
	);

}
